/* eslint-disable max-lines */
import { Lethargy } from "lethargy";
import "swiper/dist/css/swiper.css";
import "../../css/components/Carousel.scss";
import React from "react";
import Swiper from "react-id-swiper";
import Dynamic from "./Dynamic";
import Logger from "../utils/Logger";
import dom from "../utils/dom";
import g from "../utils/globals";
import { getRatio, isHomeMobile } from "../utils/helpers";
import Carousel from "./Carousel";
import api from "../utils/api";
import { getAnalyticsSpot } from "../utils/analytics";
import { features } from "../utils/features";
import { connect } from "react-redux";
import { changeMessage, closeMessage } from "../store/actions/index";

let transitioning = false;

const logger = new Logger(__filename);

let unlockScroll = null;
const lethargy = new Lethargy();

const wheelingListener = e => {
  const swiperIndex = window.swiper && window.swiper.length > 1 ? window.selectedCarousel.realIndex : 0;
  const activeSwiperContext = window.swiper && window.swiper.find(sw => sw.idx === swiperIndex);
  if (lethargy.check(e) !== false) {
    if (!transitioning) {
      transitioning = true;
      const inercedWheel = lethargy.check(e);
      if (e.deltaX !== 0) return;
      if ((Number(inercedWheel) && inercedWheel === 1) || (typeof inercedWheel === "boolean" && e.deltaY < 0)) {
        activeSwiperContext.slidePrev();
      } else {
        activeSwiperContext.slideNext();
      }
    }
    if (unlockScroll) {
      clearTimeout(unlockScroll);
    }
    unlockScroll = setTimeout(() => {
      transitioning = false;
    }, 100);
  }
};

class CarouselVertical extends Carousel {
  constructor(...args) {
    super(...args);
    this.swiper = null;
    this.looped = false;
    this.state = {
      editMode: false,
      params: {
        sectionName: this.props.sectionName,
        contents: this.props.contents,
        direction: "vertical",
        mousewheel: {
          forceToAxis: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        speed: 1000,
        on: {
          slideChange: this.slideChange,
          slidePrevTransitionStart: this.slidePrevTransitionStart,
          slideNextTransitionStart: this.slideNextTransitionStart,
          slideChangeTransitionEnd: this.slideTransitionEnd,
          sliderMove: this.sliderMove,
        },
      },
    };
    this.analytics = [];
    if (window.zara && window.zara.mkt) {
      window.zara.mkt.setEditMode = mode => this.handleEditMode(mode);
    }
    this.checkInterval = null;
    // is necessary to add this class before it loads,
    // it doesn't work at componentWillMount as expected
    dom.addBodyClass("no-overflow");
  }
  addBodyActiveSlideHandler = () => {
    if (window.swiper) {
      const swiperIndex = window.swiper.length > 1 ? window.selectedCarousel.realIndex : 0;
      const activeSwiperContext = window.swiper.find(sw => sw.idx === swiperIndex);
      if (activeSwiperContext) {
        const contentId = activeSwiperContext.slides[activeSwiperContext.activeIndex].getAttribute("data-content");
        document.body.setAttribute("data-slide", `${contentId}`);
      }
    }
  };

  componentDidMount = () => {
    if (this.props.getSwiperContext) {
      this.props.getSwiperContext(this.swiper);
    }
    if (this.props.enhancement) {
      const fileName = this.props.dataAttrs ? this.props.dataAttrs["data-content"] : null;
      if (this.props.enhancement.init && !g.enhancementsLoaded.includes(this.props.enhancementName)) {
        try {
          this.props.enhancement.init(this);
          logger.log(`... enhancing content [${this.props.attrs.id}]`);
          g.enhancementsLoaded.push(this.props.enhancementName);
        } catch (error) {
          logger.error(`Enhancement error: ${this.props.attrs.id}`);
          logger.debug(error);
        }
      }
      if (fileName && this.props.enhancement[fileName] && this.props.enhancement[fileName].init) {
        try {
          this.props.enhancement[fileName].init();
          logger.log(`... enhancing content [${fileName}]`);
        } catch (error) {
          logger.error(`Enhancement error: ${fileName}`);
          logger.debug(error);
        }
      }
    }
    this.mouseEvents = ["mousewheel", "DOMMouseScroll", "MozMousePixelScroll"];
    for (let i = 0; i < this.mouseEvents.length; i++) {
      window.addEventListener(this.mouseEvents[i], wheelingListener);
    }
    if (features.phone) {
      document.getElementsByClassName("swiper-pagination").forEach(x => x.classList.add("fade"));
    }
    setTimeout(() => {
      if (window.swiper) {
        if ((window.swiper.length > 1 && this.props.index === window.swiper[0].realIndex) || window.swiper.length) {
          this.handleSlideMessage(this.props.contents[this.swiper.activeIndex], true);
        }
      }
    }, 100);
  };

  componentWillReceiveProps = nextProps => {
    if (nextProps.contents !== this.props.contents) {
      this.looped = false;
      logger.log("Carousel Update");
      this.forceUpdate();
    }
  };

  componentDidUpdate = () => {
    if (window.zara) {
      if (this.state.editMode) {
        window.zara.mkt.swiper = this.swiper;
      } else if (window.zara.mkt.swiper) {
        window.zara.mkt.swiper = null;
      }
    }
  };

  componentWillUnmount = () => {
    dom.removeBodyClass("no-overflow");
    this.handleFooter("footer");
    window.swiper = null;
    if (this.checkInterval) clearInterval(this.checkInterval);
    window.swiper = null;
    this.analytics = [];
    for (let i = 0; i < this.mouseEvents.length; i++) {
      window.removeEventListener(this.mouseEvents[i], wheelingListener);
    }
  };

  handleInit = () => {
    this.addBodyActiveSlideHandler();
    if ((window.swiper && window.swiper.length > 1 && this.props.index === window.swiper[0].realIndex) || window.swiper.length === 1) {
      const customProps = this.props.contents[0].customProps;
      if (customProps.bodyClassName) {
        dom.addBodyClass("white-menu");
      } else {
        dom.removeBodyClass("white-menu");
      }
      this.triggerAnalytics();
      setTimeout(this.handleFooter, 1000);
    }
  };

  handleFooter = target => {
    const destination = `slide-footer-${this.props.index || 0}`;
    const container = document.getElementById(`${destination}`);

    if (!container) return;

    const footer = document.createDocumentFragment();

    // Append desired element to the fragment:
    g.footerItems.forEach(elem => {
      const element = document.querySelector(elem);
      if (element) footer.appendChild(element);
    });

    // Append fragment to desired element:
    const realFooter = target ? document.getElementById(target) : null;
    if (realFooter) {
      realFooter.parentNode.insertBefore(footer, realFooter);
    } else if (container) {
      container.appendChild(footer);
    }
  };

  getPropsFromContent = idx => {
    const content = this.props.contents[idx];
    return content.customProps || content || {};
  };

  addToGlobal = () => {
    if (!window.swiper) {
      window.swiper = [];
      window.selectedCarousel = this.swiper;
      if (!window.swiper.destroyed) {
        window.currentCarousel = this.swiper.el.parentElement.id;
      }
    }
    if (window.selectedCarousel.destroyed || !document.getElementById(window.currentCarousel)) {
      window.selectedCarousel = this.swiper;
      window.currentCarousel = this.swiper.el.parentElement.id;
    }
    window.swiper.push(this.swiper);
    this.checkNode();
  };

  handleEditMode = mode => {
    this.setState(
      prevState => ({
        ...prevState,
        editMode: mode,
        params: {
          ...prevState.params,
          pagination: {
            el: ".swiper-pagination",
            clickable: false,
            dynamicBullets: true,
          },
          mousewheel: false,
          autoplay: null,
          threshold: null,
          noSwiping: true,
        },
      }),
      () => this.swiper.autoplay.stop()
    );
  };

  triggerAnalytics = () => {
    const analytics = this.analytics[this.swiper.realIndex];
    if (analytics) {
      api.trackEvent(analytics);
    }
  };

  slideTransitionEnd = () => {
    transitioning = false;
    this.triggerAnalytics();
    if (this.props.nestedTransition) {
      this.props.nestedTransition(false);
    }
  };

  slideChange = () => {
    this.addBodyActiveSlideHandler();
    if (!this.swiper) return;
    const wrappers = document.querySelector("#wrappers");
    const nextButton = document.querySelector(".swiper-button-next");
    const prevButton = document.querySelector(".swiper-button-prev");

    if (this.swiper.realIndex === this.props.contents.length - 1) {
      if (wrappers) wrappers.classList.add("hide");
      if (nextButton) nextButton.classList.add("hide");
      if (prevButton) prevButton.classList.add("hide");
    } else {
      if (wrappers) wrappers.classList.remove("hide");
      if (nextButton) nextButton.classList.remove("hide");
      if (prevButton) prevButton.classList.remove("hide");
    }
  };

  sliderMove = () => {
    if (this.props.nestedTransition) {
      this.props.nestedTransition(true);
    }
  };

  slideTransition = (idx, nextProps, prevProps) => {
    document.body.setAttribute("data-ui", nextProps.uiColor || "");
    dom.removeBodyClass(prevProps.bodyClassName);
    dom.removeBodyClass("white-menu");
    dom.addBodyClass(nextProps.bodyClassName);
    if (this.props.scenes && this.swiper) {
      const hasWhiteBg = this.swiper.slides[idx].nextSibling
        ? this.swiper.slides[idx].nextSibling.querySelector(".white")
        : this.swiper.slides[idx].querySelector(".white");
      if (hasWhiteBg) {
        this.props.changeUI("white");
      } else {
        this.props.changeUI("black");
      }
    }
    this.handleSlideMessage(this.props.contents[idx]);
  };

  slideNextTransitionStart = () => {
    const idx = this.swiper ? this.swiper.realIndex : 0;
    const nextProps = this.getPropsFromContent(idx);
    const prevProps = this.getPropsFromContent((idx || this.props.contents.length) - 1);
    this.slideTransition(idx, nextProps, prevProps);
  };

  slidePrevTransitionStart = () => {
    const idx = this.swiper ? this.swiper.realIndex : 0;
    const nextProps = this.getPropsFromContent(idx);
    const prevProps = this.getPropsFromContent(idx + 1 === this.props.contents.length ? 0 : idx + 1);
    this.slideTransition(idx, nextProps, prevProps);
  };

  checkNode = () => {
    dom.addBodyClass("carousel-vertical");
  };

  createAnalyics = () =>
    this.props.contents.forEach((m, k) => {
      const analytic = getAnalyticsSpot(m, k, this.props.customProps.sectionName);
      this.analytics.push(analytic);
    });

  getSlides = () =>
    this.props.contents
      .map((m, k) => {
        // we are checking all slides, so is necessary check "false"
        if (m.hasMessage === false) {
          const footerElements = [];
          g.footerItems.forEach(elem => (document.querySelector(elem) ? footerElements.push(elem) : null));
          if (footerElements.length < 1) return null;
        }
        const style = {};
        if (!isHomeMobile()) {
          style.height = `${getRatio(m.ratio)}%`;
        }
        let dataLabel = "";
        if (m.categoryUrl) {
          dataLabel = m.categoryUrl.match("'(.*)'")[1];
        }

        return (
          <div
            key={k}
            style={this.props.fullscreenStyle}
            id={`item-${k + 1}`}
            data-position={k + 1}
            data-name={m.dataAttrs ? m.dataAttrs["data-content"] || "" : ""}
            data-label={dataLabel}
            data-path={m.root || ""}
            className="item"
            {...m.dataAttrs}
            data-content={m.id}
          >
            <Dynamic {...m} index={k} carousel carouselIndex={this.props.carouselIndex} analytics={this.analytics[k]} />
          </div>
        );
      })
      .filter(x => x);

  handleOver = () => {
    if (features.phone) {
      document.getElementsByClassName("swiper-pagination").forEach(x => x.classList.remove("fade"));
    }
  };

  handleOut = () => {
    if (features.phone) {
      document.getElementsByClassName("swiper-pagination").forEach(x => x.classList.add("fade"));
    }
  };
  handleSlideMessage = ({ footer }, init) => {
    if (footer) {
      if (!this.props.userOpened) this.props.closeMessage(this.props.seenMessages.has(footer.content.content));
      this.props.changeMessage({ title: footer.content.title, content: footer.content.content || footer.content.text });
    } else if (
      ((this.props.default &&
        this.props.default.content &&
        this.props.seenMessages.has(this.props.default.content) &&
        !this.props.userOpened &&
        !this.props.closed) ||
        (!footer && !this.props.closed)) &&
      !init
    ) {
      this.props.closeMessage(true);
    } else {
      this.props.changeMessage(this.props.default || { title: "", content: "" });
    }
  };

  render = () => {
    this.createAnalyics();
    const slides = this.getSlides();
    return (
      <div
        {...this.props.attrs}
        className={`${this.props.attrs.className} _prevent-menu-unfold`}
        dir={g.direction}
        onTouchStart={this.handleOver}
        onTouchEnd={this.handleOut}
      >
        <Swiper
          {...this.state.params}
          getSwiper={swiper => {
            this.swiper = swiper;
            this.swiper.name = this.props.name;
            this.swiper.idx = this.props.index || 0;
            this.addToGlobal();
            this.handleInit();
          }}
        >
          {slides}
        </Swiper>
      </div>
    );
  };
}
const mapStateToProps = state => ({
  seenMessages: state.carouselStore.message.seenMessages,
  userOpened: state.carouselStore.message.userOpened,
  closed: state.carouselStore.message.closed,
  default: state.carouselStore.message.default,
});
const mapDispatchToProps = dispatch => ({
  changeMessage: slideMessage => dispatch(changeMessage(slideMessage)),
  closeMessage: closed => dispatch(closeMessage(closed)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CarouselVertical);
